export class SignatureHelper {
  public static getSignatureLevel(key: string): string {
    const map = new Map<string, string>();
    map.set('QESIG', 'Signature qualifiée');
    map.set('QESEAL', 'Cachet qualifé');
    map.set('QES?', 'Signature ou cachet qualifié(e)');
    map.set('ADESIG_QC', 'Signature avancée avec un certificat qualifié');
    map.set('ADESEAL_QC', 'Cachet avancé avec un certificat qualifié');
    map.set('ADES?-QC', 'Signature ou cachet avancé(e) avec un certificat qualifié');
    map.set('ADESIG', 'Signature avancée');
    map.set('ADESEAL', 'Cachet avancé');
    map.set('INDETERMINATE_QESIG', 'Signature qualifiée');
    map.set('INDETERMINATE_QESEAL', 'Cachet qualifé');
    map.set('INDETERMINATE_QES?', 'Signature ou cachet qualifié(e)');
    map.set('INDETERMINATE_ADESIG-QC', 'Signature avancée avec un certificat qualifié');
    map.set('INDETERMINATE_ADESEAL-QC', 'Cachet avancé avec un certificat qualifié');
    map.set('INDETERMINATE_ADES?-QC', 'Signature ou cachet avancé(e) avec un certificat qualifié');
    map.set('INDETERMINATE_ADESIG', 'Signature avancée');
    map.set('INDETERMINATE_ADESEAL', 'Cachet avancé');
    map.set('INDETERMINATE_ADES?', 'Signature ou cachet avancé(e)');
    map.set('NOT ADES BUT QC WITH QSCD', 'Signature non avancée avec un certificat qualifié et support qualifié eIDAS');
    map.set('NOT ADES BUT QC', 'Signature non avancée avec un certificat qualifié');
    map.set('NOT_ADES', 'Signature non avancée');
    map.set('NA', 'Non applicable');
    return map.get(key.toUpperCase());
  }

  public static getSignatureFormat(key: string): string {
    const map = new Map<string, string>();
    map.set('XML_NOT_ETSI', 'Signature XML');
    map.set('XADES_C', 'Signature XML');
    map.set('XADES_X', 'Signature XML');
    map.set('XADES_XL', 'Signature XML horodatée long terme');
    map.set('XADES_A', 'Signature XML horodatée long terme pour archivage');
    map.set('XADES_BASELINE_B', 'Signature XML');
    map.set('XADES_BASELINE_T', 'Signature XML horodatée');
    map.set('XADES_BASELINE_LT', 'Signature XML horodatée long terme');
    map.set('XADES_BASELINE_LTA', 'Signature XML horodatée long terme pour archivage');
    map.set('CMS_NOT_ETSI', 'Signature CMS');
    map.set('CADES_101733_C', 'Signature CMS');
    map.set('CADES_101733_X', 'Signature CMS');
    map.set('CADES_101733_A', 'Signature CMS horodatée long terme pour archivage');
    map.set('CADES_BASELINE_B', 'Signature CMS');
    map.set('CADES_BASELINE_T', 'Signature CMS horodatée');
    map.set('CADES_BASELINE_LT', 'Signature CMS horodatée long terme');
    map.set('CADES_BASELINE_LTA', 'Signature CMS horodatée long terme pour archivage');
    map.set('PDF_NOT_ETSI', 'Signature PDF');
    map.set('PKCS7_B', 'Signature PDF');
    map.set('PKCS7_T', 'Signature PDF horodatée');
    map.set('PKCS7_LT', 'Signature PDF horodatée long terme');
    map.set('PKCS7_LTA', 'Signature PDF horodatée long terme pour archivage');
    map.set('PADES_BASELINE_B', 'Signature PDF');
    map.set('PADES_BASELINE_T', 'Signature PDF horodatée');
    map.set('PADES_BASELINE_LT', 'Signature PDF horodatée long terme');
    map.set('PADES_BASELINE_LTA', 'Signature PDF horodatée long terme pour archivage');
    return map.get(key.toUpperCase());
  }

  public static getSecurityLevel(key: string): string {
    const map = new Map<string, string>();
    map.set('QC', 'Qualifié eIDAS');
    map.set('QCP', 'Qualifié eIDAS');
    map.set('NCP+', 'Non qualifié eIDAS (ETSI NCP+)');
    map.set('NCP', 'Non qualifié eIDAS (ETSI NCP)');
    map.set('LCP', 'Non qualifié eIDAS (ETSI LCP)');
    map.set('RGS3E', 'Non qualifié eIDAS (RGS ***)');
    map.set('RGS3', 'Non qualifié eIDAS (RGS ***)');
    map.set('RGS2E', 'Non qualifié eIDAS (RGS **)');
    map.set('RGS2', 'Non qualifié eIDAS (RGS **)');
    map.set('RGS1E', 'Non qualifié eIDAS (RGS *)');
    map.set('RGS1', 'Non qualifié eIDAS (RGS *)');
    map.set('UNKNOWN', 'Non qualifié eIDAS');
    map.set('TMSTMP', 'Non qualifié eIDAS');
    map.set('PKC', 'Non qualifié eIDAS');
    return map.get(key.toUpperCase());
  }
}
